// ============================================================
// useNotificationListener.ts
// Écoute l'événement WS NOTIFICATION_NEW :
//   - Ajoute la notif au Redux (panneau + badge)
//   - Si popup=true → toast immédiat via SnackbarProvider
//
// À monter UNE FOIS dans un composant haut-niveau (Navbar) qui
// existe pendant toute la session authentifiée.
// ============================================================

import { useDispatch } from 'react-redux';
import { AppDispatch } from '../reduxStore/Store';
import { useWsEvent } from './useWsEvent';
import { WsEventType, InAppNotificationPayload } from '../websocket/WsEvents';
import { addNotificationFromWs, fetchUnreadCount, pushToast } from '../reduxStore/NotificationSlice';
import { Notification } from '../models/models';

export function useNotificationListener(): void {
  const dispatch = useDispatch<AppDispatch>();

  useWsEvent<InAppNotificationPayload>(WsEventType.NOTIFICATION_NEW, (event) => {
    const p = event.payload;

    // Construire l'objet Notification minimal pour le panneau
    // (les champs détaillés source/metadata/expires_at seront à jour au prochain fetch)
    const notif: Notification = {
      id:         p.notification_id,
      owner_id:   event.owner_id,
      user_id:    p.user_id,
      source:     'SYSTEM',          // valeur par défaut, sera écrasée au prochain fetch
      titre:      p.titre,
      message:    p.message,
      niveau:     p.niveau,
      popup:      p.popup,
      lien:       p.lien,
      lu:         false,
      created_at: event.timestamp,
    };

    dispatch(addNotificationFromWs(notif));
    // Resync compteur depuis le serveur (source de vérité — robuste aux missed events)
    dispatch(fetchUnreadCount());

    // popup=true → toast persistant rendu par <NotificationToastStack />
    // (l'utilisateur le ferme manuellement via le bouton ✕)
    if (p.popup) {
      dispatch(pushToast({
        notification_id: p.notification_id,
        titre:           p.titre,
        message:         p.message,
        niveau:          p.niveau,
        lien:            p.lien,
        arrived_at:      Date.now(),
      }));
    }
  });
}
